import { Box } from "@mui/material";

import { tk } from "@thalamos/vision-common";

import { TypographyI18N } from "../components/index.js";

export const TrainingBanner = () => {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1301, // Above the AppBar
        width: "100%",
        bgcolor: "error.main",
        color: "common.white",
        px: 2,
        py: 1,
        textAlign: "center",
      }}
    >
      <TypographyI18N
        translationKey={tk("trainingBanner.content")}
        variant="body2"
        fontWeight="bold"
      />
    </Box>
  );
};
